import { useCallback, useEffect, useState } from 'react';
import { api, type ActivityEntry } from '../../api.js';

const POLL_INTERVAL_MS = 30_000;

export function useActivity(): {
  entries: ActivityEntry[];
  loading: boolean;
  error: string | null;
} {
  const [entries, setEntries] = useState<ActivityEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      const r = await api.getActivity();
      setEntries(r.entries);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const interval = setInterval(load, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [load]);

  return { entries, loading, error };
}
